
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.87 20a2.5 2.5 0 01-2.5 2.5H22.5v8.88a2.5 2.5 0 01-5 0V22.5H8.62a2.5 2.5 0 110-5h8.88V8.62a2.5 2.5 0 015 0v8.88h8.87a2.5 2.5 0 012.5 2.5z","fill":"#fff"}})])
          )
        }
      }
    